import { extend } from 'vee-validate';
import { errorMessages } from '@/globals/errorMessages';
import { email, max, min, regex, required } from 'vee-validate/dist/rules';

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: errorMessages.ERROR_CONFIRM_PASSWORD,
});
extend('required', {
  ...required,
  message: '{_field_}は必要項目です',
});
extend('email', {
  ...email,
  message: errorMessages.INVALID_EMAIL,
});
extend('regex', {
  ...regex,
  message: '使用必須文字',
});
extend('max', {
  validate(value, { length }) {
    return value.length >= length;
  },
  ...max,
  params: ['length'],
  message: '{length}以下を入力してください',
});

extend('emailMax', {
  validate(value, { length }) {
    return !value || value.length <= length;
  },
  params: ['length'],
  message: errorMessages.EMAIL_MAX_LENGTH,
});

extend('min', {
  validate(value, { length }) {
    return value.length >= length;
  },
  ...min,
  params: ['length'],
  message: '{length}以上を入力してください',
});

extend('noteq', {
  params: ['old'],
  validate: (value, params) => {
    return params.old != value;
  },
  message: ' ',
});

extend('minmax', {
  params: [
    {
      name: 'min',
      cast: (value) => {
        return Number(value);
      },
    },
    {
      name: 'max',
      cast: (value) => {
        return Number(value);
      },
    },
  ],
  validate: (value, params) => {
    return (
      params.min <= value.toString().length &&
      params.max >= value.toString().length
    );
  },
  message: (field, params) => {
    return errorMessages.MINMAXLENGTH.replace('xx', params.min).replace(
      'yy',
      params.max
    );
  },
});

extend('passwordValidChars', {
  validate(value) {
    const regex = /^[0-9a-zA-Z^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]+$/;
    return regex.test(value);
  },
  message: errorMessages.PASSWORD_INVALID_CHARS,
});

extend('symbol', {
  validate(value) {
    const regex = /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]+/;
    return regex.test(value);
  },
  message: errorMessages.PASSWORD_SYMBOL_REQUIRED,
});

extend('passwordLowercase', {
  validate(value) {
    const regex = /(?=.*[a-z])/;
    return regex.test(value);
  },
  message: errorMessages.PASSWORD_LOWERCASE_REQUIRED,
});

extend('passwordUppercase', {
  validate(value) {
    const regex = /(?=.*[A-Z])/;
    return regex.test(value);
  },
  message: errorMessages.PASSWORD_UPPERCASE_REQUIRED,
});

extend('passwordNumeric', {
  validate(value) {
    const regex = /(?=.*[0-9])/;
    return regex.test(value);
  },
  message: errorMessages.PASSWORD_NUMERIC_REQUIRED,
});
